import { PageHeader, Section } from "@/components/site/PageChrome";
import { Star, Quote, PlayCircle } from "lucide-react";

const reviews = [
  {
    name: "Ramesh K.",
    role: "Resident · Anantapur",
    stars: 5,
    text: "Time2Cash helped me find someone to complete my home cleaning task within a few hours. It saved me a lot of time and effort.",
  },
  {
    name: "Priya S.",
    role: "Working Professional · Anantapur",
    stars: 5,
    text: "I needed help organizing and decorating my room. I posted my requirement and found reliable local help the very same day.",
  },
  {
    name: "Harsha V.",
    role: "College Student · Anantapur",
    stars: 5,
    text: "When my friend urgently needed blood, Time2Cash helped us connect with nearby donors quickly. It was incredibly helpful during the emergency.",
  },
  {
    name: "Mahesh Reddy",
    role: "Electronics Store Owner · Anantapur",
    stars: 5,
    text: "More customers are discovering my shop through Time2Cash. It's become an effective way to promote my business locally.",
  },
  {
    name: "Lakshmi P.",
    role: "Homeowner · Anantapur",
    stars: 5,
    text: "Finding electricians and plumbers used to be difficult. Now I simply open Time2Cash and get trusted local professionals within minutes.",
  },
  {
    name: "Naveen C.",
    role: "Furniture Shop Owner · Anantapur",
    stars: 5,
    text: "From customer enquiries to local visibility, Time2Cash has helped my business grow. Having everything on one platform makes it much easier.",
  },
  {
    name: "Suresh B.",
    role: "Resident · Anantapur",
    stars: 5,
    text: "I found a part-time helper for shifting my house through Time2Cash. The entire process was quick and hassle-free.",
  },
  {
    name: "Rafi M.",
    role: "Mobile Repair Shop · Anantapur",
    stars: 5,
    text: "Time2Cash has started bringing genuine local enquiries to my shop. It's a great platform for small businesses like ours.",
  },
  {
    name: "Swathi N.",
    role: "Teacher · Anantapur",
    stars: 5,
    text: "Instead of using multiple apps, I can now find services, local jobs, shops, and marketplace listings all in one place. Very convenient.",
  },
];

export default function ReviewsPage() {
  return (
    <>
      <PageHeader
        eyebrow="Reviews & Testimonials"
        title="Loved across Indian cities."
        subtitle="Real stories from users, shop owners, and community members who made Time2Cash part of their everyday life."
      />

      <Section>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((r, i) => (
            <div key={r.name} className={`rounded-3xl p-7 border ${i % 4 === 0 ? "bg-[#1A1918] text-white border-[#1A1918]" : "bg-white border-[#EBE8E3]"}`}>
              <Quote className="w-8 h-8 text-[#FF5A00]" />
              <p className={`mt-4 text-lg leading-relaxed ${i % 4 === 0 ? "text-white" : "text-[#1A1918]"}`}>&ldquo;{r.text}&rdquo;</p>
              <div className="mt-6 flex items-center justify-between">
                <div>
                  <div className={`font-bold ${i % 4 === 0 ? "text-white" : "text-[#1A1918]"}`}>{r.name}</div>
                  <div className={`text-xs ${i % 4 === 0 ? "text-white/60" : "text-[#78716C]"}`}>{r.role}</div>
                </div>
                <div className="flex gap-0.5">
                  {Array.from({ length: r.stars }).map((_, j) => (
                    <Star key={j} className="w-4 h-4 fill-[#FF5A00] text-[#FF5A00]" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* <p className="mt-8 text-xs text-[#78716C] italic">* Sample reviews — real customer reviews coming soon.</p> */}
      </Section>

      <Section className="bg-[#FFF9F5]">
        <h2 className="text-3xl md:text-4xl font-bold text-[#1A1918]">Video testimonials.</h2>
        <p className="mt-2 text-[#4A4846]">Community stories on video — launching soon.</p>
        <div className="mt-8 grid sm:grid-cols-3 gap-6">
          {[1, 2, 3].map((i) => (
            <div key={i} className="aspect-video rounded-2xl bg-gradient-to-br from-[#FF8A3D] to-[#FF5A00] flex items-center justify-center">
              <PlayCircle className="w-14 h-14 text-white/90" />
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
